'use client'

import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps'
import { motion } from 'framer-motion'
import { Reveal, ParallaxReveal } from '@/components/motion-primitives'

const GEO_URL = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json'

const MARKERS: { name: string; coords: [number, number] }[] = [
  { name: 'United States', coords: [-98, 39] },
  { name: 'United Kingdom', coords: [-1, 52] },
  { name: 'Nigeria', coords: [8, 9] },
  { name: 'Brazil', coords: [-51, -10] },
  { name: 'India', coords: [79, 22] },
  { name: 'Mexico', coords: [-102, 23] },
  { name: 'Singapore', coords: [104, 1.3] },
  { name: 'South Africa', coords: [24, -29] },
  { name: 'UAE', coords: [54, 24] },
  { name: 'Germany', coords: [10, 51] },
]

const CHIPS = [
  { label: 'Countries', value: '190+' },
  { label: 'Currencies', value: '40+' },
  { label: 'Payment rails', value: '60+' },
  { label: 'Stablecoins', value: '8' },
]

export function WorldMap() {
  return (
    <section className="bg-background py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-semibold uppercase tracking-wider text-brand">Global coverage</p>
          <h2 className="mt-3 text-balance text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
            One platform, worldwide reach
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            Move money across borders with local presence in the markets that matter  including NGN
            and other high-growth corridors.
          </p>
        </Reveal>

        <ParallaxReveal className="mt-12" offset={60}>
          <div className="mx-auto max-w-4xl">
            <ComposableMap
              projectionConfig={{ scale: 145 }}
              width={800}
              height={380}
              style={{ width: '100%', height: 'auto' }}
            >
              <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                  geographies.map((geo) => (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill="var(--color-muted)"
                      stroke="var(--color-border)"
                      strokeWidth={0.5}
                      style={{
                        default: { outline: 'none' },
                        hover: { fill: 'color-mix(in oklab, var(--color-brand) 25%, var(--color-muted))', outline: 'none' },
                        pressed: { outline: 'none' },
                      }}
                    />
                  ))
                }
              </Geographies>
              {MARKERS.map((m, i) => (
                <Marker key={m.name} coordinates={m.coords}>
                  <motion.circle
                    r={4}
                    fill="var(--color-brand)"
                    initial={{ scale: 0.6, opacity: 0.4 }}
                    animate={{ scale: [0.6, 1.6, 0.6], opacity: [0.5, 0, 0.5] }}
                    transition={{ duration: 2.2, repeat: Infinity, delay: i * 0.2 }}
                  />
                  <circle r={2.5} fill="var(--color-brand)" />
                </Marker>
              ))}
            </ComposableMap>
          </div>
        </ParallaxReveal>

        <div className="mx-auto mt-10 grid max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {CHIPS.map((c, i) => (
            <Reveal key={c.label} delay={i * 0.05} className="rounded-2xl border border-border bg-card p-5 text-center">
              <div className="text-2xl font-semibold text-foreground">{c.value}</div>
              <div className="mt-1 text-sm text-muted-foreground">{c.label}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
